import calculateCurrentIndexes from '@/components/Kanban/KPI/calculateIndex';

const groupInitiativesByYearActual = (initiative, key) => {
  const { currentYearIndex } = calculateCurrentIndexes();

  const hasImpact = Array.isArray(initiative.impact) && initiative.impact.length > 0;
  let category = '<not set>';

  const isBelowL3 = ['L0', 'L1', 'L2'].includes(initiative.stage);
  const isInactiveStatus = ['On Hold', 'Cancelled', 'Rejected'].includes(initiative.weeklyStatus);

  if (isBelowL3 || isInactiveStatus) {
    return 'No actuals (below L3 or cancelled/on hold)';
  }

  const validKeys = {
    '(FY23-24) Actual impact update check': { startMonthIndex: 0, endMonthIndex: 11, fyLabel: 'FY 23-24' },
    '(FY24-25) Actual impact update check': { startMonthIndex: 12, endMonthIndex: 23, fyLabel: 'FY 24-25' },
    '(FY25-26) Actual impact update check': { startMonthIndex: 24, endMonthIndex: 35, fyLabel: 'FY 25-26' },
    '(FY26-27) Actual impact update check': { startMonthIndex: 36, endMonthIndex: 47, fyLabel: 'FY 26-27' },
    '(FY27-28) Actual impact update check': { startMonthIndex: 48, endMonthIndex: 59, fyLabel: 'FY 27-28' }
  };

  const targetKeyData = validKeys[key];
  if (!targetKeyData) {
    return '<not set>';
  }

  if (!hasImpact || !initiative.hasFinancialImpact) {
    return 'No actuals required or no impacts';
  }

  const { startMonthIndex, endMonthIndex, fyLabel } = targetKeyData;
  
  let hasValidPlanInTargetFy = false;
  let allPlansHaveActuals = true;
  
  for (const imp of initiative.impact) {
    // Check monthly plans for the target FY
    if (Array.isArray(imp.monthlyPlan) && imp.monthlyPlan.length > endMonthIndex) {
      // Check all months in the target FY
      for (let monthIndex = startMonthIndex; monthIndex <= endMonthIndex; monthIndex++) {
        const planValue = imp.monthlyPlan[monthIndex];
        // Consider 0 as a valid plan value (removed && planValue !== 0)
        if (planValue !== null && planValue !== undefined) {
          hasValidPlanInTargetFy = true;
          
          // Check if there's a corresponding actual for this month
          if (Array.isArray(imp.monthlyActual) && imp.monthlyActual.length > monthIndex) {
            const actualValue = imp.monthlyActual[monthIndex];
            // Consider 0 as a filled actual value (removed && actualValue !== 0)
            if (actualValue === null || actualValue === undefined) {
              allPlansHaveActuals = false;
              break; // Found a missing actual, no need to check further months
            }
          } else {
            // monthlyActual array doesn't exist or doesn't have enough elements
            allPlansHaveActuals = false;
            break;
          }
        }
      }
      
      // If we found a missing actual in this impact, no need to check other impacts
      if (!allPlansHaveActuals) {
        break;
      }
    }
  }

  if (!hasValidPlanInTargetFy) {
    return 'No actuals required or no impacts';
  } else if (hasValidPlanInTargetFy && !allPlansHaveActuals) {
    return `Missing actual in ${fyLabel}`;
  } else if (hasValidPlanInTargetFy && allPlansHaveActuals) {
    return `Filled actual in ${fyLabel}`;
  }

  return '<not set>';
};

export default groupInitiativesByYearActual;